import React, { createContext, useContext, ReactNode } from 'react';

import { SavedSubmission, FieldWithSubmission } from '../types/formTypes';

interface FormDataContextType {
  fields: FieldWithSubmission[];
  updateFieldSubmission: (fieldId: string, submission: SavedSubmission) => void;
}

const FormDataContext = createContext<FormDataContextType | undefined>(undefined);

interface FormDataProviderProps {
  children: ReactNode;
  fields: FieldWithSubmission[];
}

export const FormDataProvider: React.FC<FormDataProviderProps> = ({ children, fields }) => {
  const [formFields, setFormFields] = React.useState<FieldWithSubmission[]>(fields);

  const updateFieldSubmission = (fieldId: string, submission: SavedSubmission) => {
    setFormFields(prevFields =>
      prevFields.map(field => (field.id === fieldId ? { ...field, submission } : field))
    );
  };

  return (
    <FormDataContext.Provider value={{ fields: formFields, updateFieldSubmission }}>
      {children}
    </FormDataContext.Provider>
  );
};

export const useFormData = () => {
  const context = useContext(FormDataContext);
  if (context === undefined) {
    throw new Error('useFormData must be used within a FormDataProvider');
  }
  return context;
};
